import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María', 'Juan', 'Carla', 'Roberto', 'Ana', 'Diego', 'Laura', 'Carlos', 'Sofía', 'Miguel'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Tucumán'];
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: ''
  });
  const [hasScrolled, setHasScrolled] = useState(false);
  // Scroll detection
  useEffect(() => {
    const handleScroll = () => {
      const scrollPercentage = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
      if (scrollPercentage > 0.3) {
        setHasScrolled(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Notification cycle
  useEffect(() => {
    if (!hasScrolled) return;
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setNotification({
        name: randomName,
        city: randomCity
      });
      setVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setVisible(false);
      }, 5000);
    };
    // Initial show
    showNotification();
    // Loop every 20 seconds
    const interval = setInterval(showNotification, 20000);
    return () => clearInterval(interval);
  }, [hasScrolled]);
  if (!visible) return null;
  return <div className="fixed bottom-4 right-4 z-50 animate-in slide-in-from-bottom-10 fade-in duration-500" data-id="element-1">
      <div className="bg-white rounded-lg shadow-lg p-4 flex items-center gap-3 border-l-4 border-teal-500 max-w-sm" data-id="element-2">
        <div className="bg-teal-100 p-2 rounded-full" data-id="element-3">
          <CheckCircle2 className="w-5 h-5 text-teal-600" data-id="element-4" />
        </div>
        <div data-id="element-5">
          <p className="text-sm font-medium text-gray-900" data-id="element-6">
            {notification.name} de {notification.city}
          </p>
          <p className="text-xs text-gray-500" data-id="element-7">
            acaba de comprar{' '}
            <span className="font-bold text-teal-600" data-id="element-8">VIVIR SIN DOLOR</span>
          </p>
        </div>
      </div>
    </div>;
}